<template>
  <div class="page-wrap">
    <div class="complaint-wrapper">
      <div class="complaint-content-wrap hidden-xs-only">
        <div class="wow animate__bounceInRight complaint-content">
          <div class="wow animate__bounceInUp complaint-content-title">
            Layanan Pengaduan
          </div>
          <div class="wow animate__bounceInUp complaint-content-lender">
            Konsumen BantuSaku
          </div>
          <div class="wow animate__bounceInUp complaint-content-anda">
            Kami berkomitmen untuk memberikan pelayanan terbaik dengan
            menghadirkan saluran pengaduan yang mudah diakses, adil, independen,
            efisien, dan optimal.
          </div>
        </div>
      </div>
      <div class="m-complaint-content-wrap hidden-sm-and-up">
        <img
          src="../assets/v3/complaint/complaint-m-banner.png"
          alt="banner"
          class="wow animate__fadeInRight m-banner"
        />
        <div class="m-complaint-content">
          <div class="wow animate__fadeInLeft content-title">
            Layanan Pengaduan
          </div>
          <div class="wow animate__fadeInLeft content-lender">
            Konsumen BantuSaku
          </div>
          <div class="wow animate__fadeInLeft content-anda">
            Kami berkomitmen untuk memberikan pelayanan terbaik dengan
            menghadirkan saluran pengaduan yang mudah diakses, adil, independen,
            efisien, dan optimal.
          </div>
        </div>
      </div>

      <div class="persyaratan-wrap">
        <div class="persyaratan-content wow animate__fadeInUp">
          <div class="persyaratan-title">Persyaratan Penyampaian Pengaduan</div>
          <div class="persyaratan-desc">
            Agar pengaduan Kamu dapat kami verifikasi dan tindak lanjuti dengan cepat, mohon lengkapi data serta dokumen berikut. Pengaduan dapat disampaikan secara <strong>tertulis</strong> maupun <strong>lisan</strong>, baik oleh Pengguna sendiri maupun melalui Perwakilan.
          </div>
          
          <div class="persyaratan-badges">
            <div class="badge-item">
              <i class="el-icon-circle-check"></i> Komitmen Pelindungan Konsumen BantuSaku
            </div>
            <div class="badge-item">
              <i class="el-icon-user"></i> Berlaku untuk Penerima Dana & Pemberi Dana
            </div>
          </div>

          <div class="persyaratan-legend">
            <span class="legend-item"><span class="legend-box legend-dark"></span> Kanal Tertulis</span>
            <span class="legend-item"><span class="legend-box legend-light"></span> Kanal Lisan</span>
          </div>

          <div class="persyaratan-table-wrap">
            <table class="persyaratan-table">
              <thead>
                <tr>
                  <th rowspan="2" class="th-dark th-center">PENGAJU</th>
                  <th rowspan="2" class="th-dark">
                    <div class="th-title">TERTULIS</div>
                    <div class="th-subtitle">Surat resmi / e-mail / Formulir Pengaduan pada aplikasi & situs BantuSaku</div>
                  </th>
                  <th colspan="2" class="th-light th-center">LISAN</th>
                </tr>
                <tr>
                  <th class="th-light-sub">LIVE CHAT / TATAP MUKA</th>
                  <th class="th-light-sub">MELALUI BANTUSAKU CALL</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td class="td-header td-bg-light-col td-center">Pengguna</td>
                  <td class="td-content td-bg-light">
                    <strong>Identitas Pengguna (KTP) yang masih berlaku</strong><br><br>
                    <strong>Data diri Pengguna, berupa:</strong>
                    <ul>
                      <li>Nama lengkap sesuai identitas.</li>
                      <li>Alamat sesuai KTP dan alamat domisili saat ini (jika berbeda).</li>
                      <li>Nomor telepon/HP aktif yang dapat dihubungi.</li>
                      <li>Alamat e-mail aktif.</li>
                    </ul>
                    <strong>Informasi pengaduan, berupa:</strong>
                    <ul>
                      <li>Nomor akun, nomor perjanjian pinjaman, atau ID transaksi terkait.</li>
                      <li>Tanggal, jam, dan nominal transaksi yang diadukan.</li>
                      <li>Kronologi singkat permasalahan yang dialami.</li>
                    </ul>
                    <strong>Dokumen pendukung lainnya</strong><br>
                    <span class="td-note">(mis. bukti transfer, tangkapan layar, riwayat transaksi).</span>
                  </td>
                  <td class="td-content">
                    Pengguna wajib melengkapi data dan dokumen yang dipersyaratkan untuk keperluan verifikasi.<br><br>
                    <span class="badge-outline">Sama seperti kanal Tertulis</span>
                  </td>
                  <td class="td-content">
                    1. Pengaduan diajukan langsung oleh Pengguna yang bersangkutan.<br><br>
                    2. Pengguna melewati proses verifikasi data untuk memastikan keabsahannya.
                  </td>
                </tr>
                <tr>
                  <td class="td-header td-bg-light-col td-center">Perwakilan<br>Pengguna</td>
                  <td class="td-content td-bg-light">
                    <strong>Bukti identitas (KTP) pemberi dan penerima kuasa yang masih berlaku</strong><br><br>
                    <strong>Surat kuasa khusus bermeterai cukup</strong><br>
                    yang ditandatangani Pengguna (pemberi kuasa) dan Perwakilan (penerima kuasa), memuat:
                    <ul>
                      <li>Tanggal dan tempat pemberian kuasa.</li>
                      <li>Nama dan Identitas pemberi serta penerima kuasa.</li>
                      <li>Hal atau perkara yang dikuasakan.</li>
                      <li>Informasi pengaduan: nomor akun/perjanjian, tanggal & jam transaksi, nominal, serta kronologi singkat.</li>
                    </ul>
                    <strong>Dokumen tambahan bila diwakili lembaga/badan hukum</strong><br>
                    <span class="td-note">(mis. akta/anggaran dasar, cap lembaga, dan surat penunjukan perwakilan).</span><br><br>
                    <strong>Dokumen pendukung pengaduan</strong><br>
                    <span class="td-note">(mis. bukti transfer, riwayat transaksi, tangkapan layar).</span>
                  </td>
                  <td class="td-content">
                    Perwakilan wajib melengkapi seluruh dokumen yang dipersyaratkan untuk keperluan verifikasi.<br><br>
                    <span class="badge-outline">Sama seperti kanal Tertulis</span>
                  </td>
                  <td class="td-content">
                    <span class="badge-outline badge-danger"><i class="el-icon-close"></i> Tidak diperkenankan</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="world-wrap">
        <div class="world-content">
          <div class="lihat wow animate__fadeInLeft">
            Saluran Pengaduan Konsumen
          </div>
          <div class="world-item-box">
            <el-row :gutter="0">
              <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8">
                <div class="world-card-item wow animate__fadeInUp">
                  <img
                    class="world-img"
                    src="../assets/v3/complaint/complaint-callcenter.png"
                    alt="world1"
                  />
                  <div>Call Center: 1500006</div>
                </div>
              </el-col>
              <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8">
                <div class="world-card-item wow animate__fadeInUp">
                  <img
                    class="world-img"
                    src="../assets/v3/complaint/complaint-whatsapp.png"
                    alt="world2"
                  />
                  <div>WhatsApp: 0889-1500-006</div>
                </div>
              </el-col>
              <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8">
                <div class="world-card-item wow animate__fadeInUp">
                  <img
                    class="world-img"
                    src="../assets/v3/complaint/complaint-email.png"
                    alt="world3"
                  />
                  <div>Email: pengaduan@bantusaku.id</div>
                </div>
              </el-col>
            </el-row>

            <el-row :gutter="0">
              <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8">
                <div class="world-card-item wow animate__fadeInUp">
                  <img
                    class="world-img"
                    src="../assets/v3/complaint/complaint-socmed.png"
                    alt="world1"
                  />
                  <div>Media Sosial</div>
                </div>
              </el-col>
              <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8">
                <div class="world-card-item wow animate__fadeInUp">
                  <img
                    class="world-img"
                    src="../assets/v3/complaint/complaint-afpi.png"
                    alt="world2"
                  />
                  <div>AFPI</div>
                </div>
              </el-col>
              <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8">
                <div class="world-card-item wow animate__fadeInUp">
                  <img
                    class="world-img"
                    src="../assets/v3/complaint/complaint-ojk.png"
                    alt="world3"
                  />
                  <div>OJK</div>
                </div>
              </el-col>
            </el-row>
          </div>
          <div class="complaint-process-content">
            <div class="advantage-item-box">
              <div class="lihat wow animate__fadeInLeft">
                Proses Penanganan Pengaduan Konsumen
              </div>
              <el-row :gutter="70">
                <el-col :xs="24" :sm="24" :md="24" :lg="8" :xl="8">
                  <div class="advantage-card-item wow animate__fadeInLeft">
                    <img
                      class="advantage1-title"
                      src="../assets/v3/lender/advantage1.png"
                      alt="advantage1"
                    />
                    <div class="advantage1-text">
                      Customer Service kami akan menerima setiap pengaduan yang
                      masuk dan melakukan analisis menyeluruh terhadap isinya.
                      Setelah itu, pengaduan konsumen akan diproses dengan
                      estimasi waktu penyelesaian selama 10 (sepuluh) hari
                      kerja. Langkah berikutnya, pengaduan akan diteruskan
                      kepada departemen terkait yang relevan untuk dilakukan
                      investigasi secara detail.
                    </div>
                  </div>
                </el-col>
                <el-col :xs="24" :sm="24" :md="24" :lg="8" :xl="8">
                  <div class="advantage-card-item wow animate__fadeInLeft">
                    <img
                      class="advantage1-title"
                      src="../assets/v3/lender/advantage2.png"
                      alt="advantage1"
                    />
                    <div class="advantage1-text">
                      Departemen yang menerima pengaduan akan melakukan
                      investigasi menyeluruh guna mengidentifikasi penyebab
                      utama permasalahan. Seluruh temuan akan dianalisis untuk
                      mencari langkah terbaik, lalu dikembangkan menjadi
                      rekomendasi yang dapat diterapkan sebagai solusi dari
                      permasalahan pengaduan konsumen.
                    </div>
                  </div>
                </el-col>
                <el-col :xs="24" :sm="24" :md="24" :lg="8" :xl="8">
                  <div class="advantage-card-item wow animate__fadeInRight">
                    <img
                      class="advantage1-title"
                      src="../assets/v3/lender/advantage3.png"
                      alt="advantage1"
                    />
                    <div class="advantage1-text">
                      Setelah solusi ditetapkan, Customer Service akan
                      menginformasikan hasil penyelesaian pengaduan secara jelas
                      dan rinci kepada konsumen. Langkah ini memastikan konsumen
                      memahami solusi yang diberikan serta merasa puas dengan
                      proses penanganan pengaduan yang telah dilakukan.
                    </div>
                  </div>
                </el-col>
              </el-row>
            </div>
          </div>
          <div class="handling-wrap">
            <div class="handling-card">
              <div class="lihat wow animate__fadeInLeft">
                <div class="laporan-title">Penanganan Pengaduan</div>
              </div>
              <div class="smartec wow animate__fadeInLeft">
                Setiap tahun, BantuSaku selalu menyelesaikan seluruh pengaduan
                konsumen dari berbagai kanal sesuai dengan ketentuan Otoritas
                Jasa Keuangan
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="complaint-wrap">
        <div class="complaint-table-card">
          <div class="table-year">Tahun 2025</div>
          <el-table
            class="complaint-table"
            :data="tableData"
            header-align="center"
            stripe
            style="width: 100%"
          >
            <el-table-column prop="Item" label="Item" min-width="300" />
            <el-table-column align="center" prop="Jan" label="Jan" />
            <el-table-column align="center" prop="Feb" label="Feb" />
            <el-table-column align="center" prop="Mar" label="Mar" />
            <el-table-column align="center" prop="Apr" label="Apr" />
            <el-table-column align="center" prop="May" label="May" />
            <el-table-column align="center" prop="Jun" label="Jun" />
            <el-table-column align="center" prop="Jul" label="Jul" />
            <el-table-column align="center" prop="Aug" label="Aug" />
            <el-table-column align="center" prop="Sep" label="Sep" />
            <el-table-column align="center" prop="Oct" label="Oct" />
            <el-table-column align="center" prop="Nov" label="Nov" />
            <el-table-column align="center" prop="Dec" label="Dec" />
            <el-table-column align="center" prop="Total" label="Total" />
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { WOW } from "wowjs";
export default {
  name: 'Pengaduan',
  data() {
    return {
      tableData: [
        {
          Item: "Pengaduan terkait performa perjanjian pinjam meminjam (Produk)",
          Jan: "0",
          Feb: "0",
          Mar: "3",
          Apr: "4",
          May: "1",
          Jun: "1",
          Jul: "0",
          Aug: "3",
          Sep: "2",
          Oct: "5",
          Nov: "0",
          Dec: "0",
          Total: "19",
        },
        {
          Item: "Pengaduan terkait penyalahgunaan dana (Transaksi Palsu, Money Laundry)",
          Jan: "0",
          Feb: "0",
          Mar: "0",
          Apr: "0",
          May: "0",
          Jun: "0",
          Jul: "0",
          Aug: "0",
          Sep: "0",
          Oct: "0",
          Nov: "0",
          Dec: "0",
          Total: "0",
        },
        {
          Item: "Pengaduan terkait penyalahgunaan data (Akses Ilegal, Kontak Telepon Penyimpanan, Fraud Eksternal)",
          Jan: "1",
          Feb: "4",
          Mar: "3",
          Apr: "4",
          May: "1",
          Jun: "1",
          Jul: "1",
          Aug: "2",
          Sep: "2",
          Oct: "6",
          Nov: "3",
          Dec: "1",
          Total: "29",
        },
        {
          Item: "Kegagalan sistem elektronik (Website Error, Aplikasi Error)",
          Jan: "2",
          Feb: "1",
          Mar: "3",
          Apr: "4",
          May: "1",
          Jun: "5",
          Jul: "5",
          Aug: "1",
          Sep: "3",
          Oct: "1",
          Nov: "0",
          Dec: "0",
          Total: "26",
        },
        {
          Item: "Cyber bullying dan penagihan (Pengancaman, Intimidasi, Kata - Kata Kasar dan Hinaan)",
          Jan: "6",
          Feb: "3",
          Mar: "5",
          Apr: "2",
          May: "4",
          Jun: "3",
          Jul: "8",
          Aug: "8",
          Sep: "12",
          Oct: "10",
          Nov: "9",
          Dec: "9",
          Total: "79",
        },
        {
          Item: "Penagihan (Tidak Terdapat Pelanggaran Oleh Petugas Penagihan)",
          Jan: "33",
          Feb: "66",
          Mar: "56",
          Apr: "49",
          May: "53",
          Jun: "63",
          Jul: "92",
          Aug: "54",
          Sep: "72",
          Oct: "127",
          Nov: "117",
          Dec: "138",
          Total: "920",
        },
        {
          Item: "Pengajuan Restrukturisasi",
          Jan: "37",
          Feb: "35",
          Mar: "12",
          Apr: "22",
          May: "15",
          Jun: "31",
          Jul: "32",
          Aug: "17",
          Sep: "28",
          Oct: "25",
          Nov: "29",
          Dec: "21",
          Total: "304",
        },
        {
          Item: "Pengaduan Bukan Kewenangan Platform",
          Jan: "0",
          Feb: "0",
          Mar: "0",
          Apr: "0",
          May: "2",
          Jun: "2",
          Jul: "11",
          Aug: "5",
          Sep: "3",
          Oct: "4",
          Nov: "5",
          Dec: "13",
          Total: "45",
        },
        {
          Item: "Pengaduan Terkait Permintaan Administrasi (Penutupan akun)",
          Jan: "",
          Feb: "",
          Mar: "",
          Apr: "",
          May: "",
          Jun: "",
          Jul: "",
          Aug: "",
          Sep: "",
          Oct: "4",
          Nov: "3",
          Dec: "1",
          Total: "8",
        },
        {
          Item: "Total",
          Jan: "79",
          Feb: "109",
          Mar: "82",
          Apr: "85",
          May: "77",
          Jun: "106",
          Jul: "149",
          Aug: "90",
          Sep: "122",
          Oct: "182",
          Nov: "166",
          Dec: "183",
          Total: "1430",
        },
      ],
    };
  },
  mounted() {
    this.$nextTick(() => {
      const wow = new WOW({ animateClass: "animated", offset: 0 });
      wow.init();
    });
  }
};
</script>

<style lang="scss" scoped>
/* =============================
   Variables & mixins (single source)
   ============================= */
$maxw: 1400px;
$space-xxl: 80px;
$space-xl: 60px;
$space-lg: 48px;
$space-md: 32px;
$space-sm: 16px;
$space-xs: 8px;

$color-bg: #c6e8ed;
$color-text: #1d1d1d;
$color-accent: #145246;

$bp-md: 768px; // phones + small tablets
$bp-sm: 480px; // very small phones

@mixin respond($bp) { @media (max-width: $bp) { @content; } }


/* =============================
   Complaint styles
   ============================= */
.complaint-wrapper {
  width: 100%;
  min-height: 100vh;
  color: $color-text;

  .lihat { font-size: 44px; font-weight: 600; margin: $space-lg 0 ($space-lg + 2px) 0; }

  .complaint-content-wrap {
    width: 100%;
    height: 470px;
    background: #ffffff;
    .complaint-content {
      max-width: $maxw;
      height: 470px;
      margin: 0 auto;
      padding: $space-xl 0 0 0;
      background: url("../assets/v3/complaint/complaint-banner.png") no-repeat;
      background-size: 100% 100%;
      .complaint-content-title { font-weight: 600; color: $color-text; font-size: 44px; }
      .complaint-content-lender { font-weight: 600; color: $color-accent; font-size: 36px; margin-top: 10px; }
      .complaint-content-anda { width: 510px; font-size: 28px; color: $color-text; margin: 17px 0 33px 0; }
      img { width: 189px; }
    }
  }

  .m-complaint-content-wrap {
    width: 100%;
    min-height: 418px;
    background: $color-bg;
    font-size: 20px;
    .m-banner { width: 100%; height: 230px; }
    .m-complaint-content {
      padding: 0 50px 0 40px; box-sizing: border-box;
      .content-title { margin: 10px 0 8px; }
      .content-lender { color: $color-accent; margin-bottom: 16px; }
      .content-anda { font-size: 16px; margin-bottom: 9px; }
      img { width: 124px; height: 35px; margin-bottom: 16px; }
    }
  }

  .world-wrap {
    width: 100%; position: relative; background: #fbffff;
    .world-content {
      max-width: $maxw; margin: 0 auto; padding: 98px 0 0 0; box-sizing: border-box;
      background: url("../assets/v3/lender/world.png") no-repeat top center / 80%;
      overflow: hidden;
      .world-item-box {
        margin-bottom: 180px;
        .world-card-item {
          text-align: center; font-size: 34px; font-weight: 700;
          .world-img { width: 100px; height: 100px; margin: 20px 0 40px; }
          div { font-size: 20px; color: $color-text; }
        }
      }
      .complaint-process-content {
        .advantage-item-box {
          .advantage-card-item { margin-bottom: 80px; }
          .advantage1-title { width: 40px; height: 40px; }
          .advantage1-text { width: 306px; min-height: 156px; font-size: 18px; line-height: 28px; margin-top: 20px; }
          .advantage1-img { width: 326px; height: 304px; }
        }
      }
    }
  }

  .handling-wrap {
    width: 100%; margin-top: 30px; padding-bottom: $space-xxl; box-sizing: border-box;
    background: url("../assets/v3/team/team-banner.png") no-repeat top / 100% 200%;
    .handling-card { max-width: $maxw; margin: 0 auto; box-sizing: border-box; }
    .laporan-box { display: flex; align-items: center; gap: 10px; }
    .laporan-box .laporan-title, .laporan-box .keuangan { font-size: 44px; font-weight: 700; }
    .laporan-box .laporan-title { color: $color-text; }
    .laporan-box .keuangan { color: #2e5a44; }
    .smartec { max-width: 100%; width: 100%; overflow-wrap: anywhere; word-break: break-word; }
  }

  .complaint-wrap {
    width: 100%; background: $color-bg;
    .complaint-table-card {
      max-width: $maxw; width: 100%; margin: 0 auto; padding: $space-xl; box-sizing: border-box; overflow-x: auto;
      .complaint-table { width: 100%; cursor: pointer; }
      .table-year {
        font-size: 24px;
        font-weight: 700;
        margin-bottom: 20px;
        color: $color-text;
        text-align: center;
      }
    }
  }
}

/* Element UI table tweaks */
:deep(.complaint-table th:nth-child(1) .cell),
:deep(.complaint-table td:nth-child(1) .cell) { white-space: normal; overflow-wrap: anywhere; font-weight: 400; font-size: 14px; }
:deep(.complaint-table colgroup col:nth-child(1)) { min-width: 300px; }


@include respond($bp-md) {
  .complaint-wrapper {
    .lihat { font-size: 24px; margin: 24px 0 16px; }
    .complaint-content-wrap { height: auto; }
    .complaint-content-wrap .complaint-content {
      height: auto; padding: $space-md $space-sm; background-size: cover; background-position: center;
      .complaint-content-title { font-size: 26px; }
      .complaint-content-lender { font-size: 20px; margin-top: 6px; }
      .complaint-content-anda { width: 100%; font-size: 16px; line-height: 24px; margin: 16px 0; }
      img { width: 140px; }
    }
    .m-complaint-content-wrap { min-height: unset; }
    .m-complaint-content-wrap .m-banner { height: 180px; }
    .m-complaint-content-wrap .m-complaint-content { padding: 0 $space-sm; }
    .m-complaint-content-wrap .content-title { font-size: 22px; margin: 12px 0 6px; }
    .m-complaint-content-wrap .content-lender { font-size: 18px; margin-bottom: 12px; }
    .m-complaint-content-wrap .content-anda { font-size: 14px; line-height: 22px; margin-bottom: 8px; }

    .world-wrap .world-content { padding: $space-md $space-sm 0; background-size: 120%; }
    .world-wrap .world-content .world-item-box { margin-bottom: $space-md + 16px; }
    .world-wrap .world-content .world-card-item { padding: $space-sm 12px; margin-bottom: $space-sm; font-size: 18px; }
    .world-wrap .world-content .world-card-item .world-img { width: 96px; height: 96px; margin: 8px 0 12px; }
    .world-wrap .world-content .world-card-item div { font-size: 16px; font-weight: 600; }

    .complaint-process-content .advantage-item-box .advantage-card-item { margin-bottom: 24px; padding: $space-sm; text-align: left; }
    .complaint-process-content .advantage-item-box .advantage1-title { width: 28px; height: 28px; }
    .complaint-process-content .advantage-item-box .advantage1-text { width: 100%; min-height: unset; font-size: 14px; line-height: 22px; margin-top: 12px; }

    .handling-wrap { margin-top: $space-sm; padding-bottom: $space-md; background-size: cover; }
    .handling-wrap .handling-card { padding: 0 $space-sm; }
    .handling-wrap .laporan-box { flex-wrap: wrap; gap: 4px; }
    .handling-wrap .laporan-box .laporan-title, .handling-wrap .laporan-box .keuangan { font-size: 24px; line-height: 1.2; }
    .handling-wrap .smartec { font-size: 14px; line-height: 22px; margin-top: 8px; padding-right: 0; }

    .complaint-wrap .complaint-table-card { max-width: 100%; padding: $space-sm; }
  }

  :deep(.complaint-table th .cell),
  :deep(.complaint-table td .cell) { font-size: 12px; line-height: 18px; padding: 8px 6px; white-space: nowrap; }
  :deep(.complaint-table th:nth-child(1) .cell),
  :deep(.complaint-table td:nth-child(1) .cell) { white-space: normal; overflow-wrap: anywhere; font-size: 12px; line-height: 18px; }
  :deep(.complaint-table .el-table__header-wrapper) { position: sticky; top: 0; z-index: 2; }
}
@include respond($bp-sm) {
  .complaint-wrapper {
    .m-complaint-content-wrap .m-banner { height: 150px; }
    .world-wrap .world-content .world-item-box .world-card-item { font-size: 16px; }
    .world-wrap .world-content .world-item-box .world-card-item .world-img { width: 84px; height: 84px; }
    .world-wrap .world-content .world-item-box .world-card-item div { font-size: 14px; }
    .complaint-content-wrap .complaint-content { padding: 20px 12px; }
    .complaint-content-wrap .complaint-content .complaint-content-title { font-size: 22px; }
    .complaint-content-wrap .complaint-content .complaint-content-lender { font-size: 18px; }
    .complaint-content-wrap .complaint-content .complaint-content-anda { font-size: 14px; line-height: 22px; }
  }
  :deep(.complaint-table th .cell),
  :deep(.complaint-table td .cell) { font-size: 11px; padding: 6px 4px; }
}

.persyaratan-wrap {
  width: 100%;
  background-color: #fff;
  padding: 60px 0;
}
.persyaratan-content {
  width: 1170px;
  margin: 0 auto;
}
.persyaratan-title {
  font-size: 38px;
  font-weight: bold;
  color: #1D1D1D;
  margin-bottom: 20px;
}
.persyaratan-desc {
  font-size: 16px;
  line-height: 28px;
  color: #333;
  margin-bottom: 25px;
  width: 80%;
}
.persyaratan-badges {
  display: flex;
  gap: 15px;
  margin-bottom: 25px;
}
.badge-item {
  border: 1px solid #145246;
  border-radius: 20px;
  padding: 6px 16px;
  font-size: 14px;
  color: #145246;
  background-color: #f9fdfa;
  display: flex;
  align-items: center;
  gap: 8px;
}
.persyaratan-legend {
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
}
.legend-item {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: #333;
  font-weight: 600;
}
.legend-box {
  width: 14px;
  height: 14px;
  border-radius: 3px;
}
.legend-dark {
  background-color: #145246;
}
.legend-light {
  background-color: #ACDDB1;
}
.persyaratan-table-wrap {
  width: 100%;
  overflow-x: auto;
  border: 1px solid #E6E6E6;
  border-radius: 8px;
}
.persyaratan-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
  line-height: 22px;
  color: #333;
}
.persyaratan-table th, .persyaratan-table td {
  border: 1px solid #E6E6E6;
  padding: 20px;
  vertical-align: top;
}
.persyaratan-table .th-dark {
  background-color: #145246;
  color: #fff;
  text-align: left;
}
.persyaratan-table .th-light {
  background-color: #ACDDB1;
  color: #145246;
}
.persyaratan-table .th-light-sub {
  background-color: #ACDDB1;
  color: #145246;
  text-align: left;
}
.persyaratan-table .th-center, .persyaratan-table .td-center {
  text-align: center;
  vertical-align: middle;
}
.persyaratan-table .th-title {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 5px;
}
.persyaratan-table .th-subtitle {
  font-size: 12px;
  font-weight: normal;
}
.persyaratan-table .td-header {
  font-weight: bold;
  color: #145246;
  width: 12%;
}
.persyaratan-table .td-bg-light-col {
  background-color: #E8F5E9;
}
.persyaratan-table .td-bg-light {
  background-color: #f3faf4;
}
.persyaratan-table .td-content {
  width: 29%;
}
.persyaratan-table .td-content ul {
  padding-left: 18px;
  margin: 8px 0 15px 0;
}
.persyaratan-table .td-content li {
  margin-bottom: 6px;
}
.persyaratan-table .td-note {
  font-style: italic;
  font-size: 13px;
  color: #666;
}
.badge-outline {
  border: 1px solid #145246;
  color: #145246;
  border-radius: 20px;
  padding: 4px 12px;
  font-size: 13px;
  display: inline-block;
  font-weight: 600;
}
.badge-danger {
  border-color: #E74C3C;
  color: #E74C3C;
}

@media (max-width: 1400px) {
  .persyaratan-content {
    width: 100%;
    padding: 0 20px;
    box-sizing: border-box;
  }
}
@media (max-width: 768px) {
  .persyaratan-desc {
    width: 100%;
  }
  .persyaratan-badges {
    flex-direction: column;
  }
}

</style>
